import React, { useContext, useEffect, useRef, useState } from 'react';
import { useMainSectionParameter } from 'components/Dashboard/helpers/useMainSectionParameter';
import InboxBar from './InboxBar';
import SearchResultsBar from './SearchResultsBar';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import { store } from 'components/Store';
import { useLocation } from 'react-router-dom';
import MainListActionsBar from 'components/Dashboard/SubNav/MainListActionsBar';
import AddUpdatesToReport from 'components/Dashboard/SubNav/ui/AddUpdatesToReport';
import { ReportsPopup } from 'components/Dashboard/Navigation/NotFeaturePopups';
import RegulationDocumentBar from 'components/Dashboard/SubNav/RegulationDocumentBar';

const SubNav = (props) => {
  const globalState = useContext(store);
  const { dispatch, state } = globalState;

  const { createReportFromUpdatePopup, selectedUpdates, activePlan } = state ?? {};
  const [isOpenReportPopup, setIsOpenReportPopup] = useState(false);
  const [isOpenLoggedOut, setIsOpenLoggedOut] = useState(false);
  const [singleUpdate, setSingleUpdate] = useState(null);

  const { enableReports } = activePlan ?? {};

  const location = useLocation();
  const { inboxSection, referenceSection, searchResultsSection, regulationDocumentSection } = useMainSectionParameter();
  const memoryMasterTopic = useRef(null);
  memoryMasterTopic.current = () => {
    if (location.pathname.includes('/monitor-inbox')) {
      let memory = getUrlParam('topic-id') === 'all';
      dispatch({ type: 'MODIFY_SECTION', parameter: 'memoryMasterTopic', value: memory });
    }
  };

  useEffect(() => {
    memoryMasterTopic.current();
  }, [location.search]);

  useEffect(() => {
    if (createReportFromUpdatePopup?.open && !isOpenReportPopup) {
      if (enableReports) {
        setIsOpenReportPopup(true);
      } else {
        setIsOpenLoggedOut(true);
      }
      setSingleUpdate(createReportFromUpdatePopup?.update);
    }
  }, [createReportFromUpdatePopup]);

  const updatesToSend = singleUpdate ? [singleUpdate] : selectedUpdates;

  return (
    <>
      <div className='position-relative'>
        <MainListActionsBar setIsOpenReportPopup={setIsOpenReportPopup} setIsOpenLoggedOut={setIsOpenLoggedOut} />
        {inboxSection && <InboxBar />}
        {(searchResultsSection || referenceSection) && <SearchResultsBar />}
        {regulationDocumentSection && <RegulationDocumentBar />}
      </div>
      <AddUpdatesToReport
        selectedUpdates={updatesToSend}
        setSingleUpdate={setSingleUpdate}
        isOpen={isOpenReportPopup}
        setIsOpen={setIsOpenReportPopup}
        fromMainList={true}
      />

      <ReportsPopup isOpen={isOpenLoggedOut} setIsOpen={setIsOpenLoggedOut} />
    </>
  );
};

export default SubNav;
